import { render, staticRenderFns } from "./SmallCardProduct.vue?vue&type=template&id=20aaa09e&"
import script from "./SmallCardProduct.vue?vue&type=script&lang=js&"
export * from "./SmallCardProduct.vue?vue&type=script&lang=js&"
import style0 from "./SmallCardProduct.vue?vue&type=style&index=0&id=20aaa09e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports